const isInternalAppPath = (path) => typeof path === 'string'
  && path.startsWith('/')
  && !path.startsWith('//');

export const buildNewTabAppUrl = (path, origin = window.location.origin) => {
  if (!isInternalAppPath(path)) return origin;
  return `${origin.replace(/\/$/, '')}${path}`;
};
